import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import useCodonationAnalytics from './useCodonationAnalytics';
import useDonationFormContext from '@/donationPages/_dependencies/helpers/useDonationFormContext';
import useDonationFormValues from '@/donationPages/_dependencies/helpers/useDonationFormValues';
function useCodonationValue() {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["codonation_cents"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [codonationCents] = useDonationFormValues(t0);
  const {
    setValue: setFormValue
  } = useDonationFormContext();
  const valueRef = useRef(codonationCents);
  const [value, internalSetValue] = useState(codonationCents);
  const {
    commitHandler: commitAnalyticsState,
    reset: resetAnalyticsState,
    changeValue: changeAnalyticsValue
  } = useCodonationAnalytics(codonationCents);
  let t1;
  if ($[1] !== commitAnalyticsState || $[2] !== setFormValue) {
    t1 = () => {
      setFormValue("codonation_cents", valueRef.current, {
        shouldTouch: true,
        shouldValidate: true,
        shouldDirty: true
      });
      commitAnalyticsState();
    };
    $[1] = commitAnalyticsState;
    $[2] = setFormValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const commitValue = t1;
  let t2;
  if ($[4] !== changeAnalyticsValue) {
    t2 = value_0 => {
      internalSetValue(value_0);
      changeAnalyticsValue(value_0);
      valueRef.current = value_0;
    };
    $[4] = changeAnalyticsValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setValue = t2;
  let t3;
  let t4;
  if ($[6] !== codonationCents || $[7] !== setValue) {
    t3 = () => {
      const timeout = setTimeout(() => setValue(codonationCents), 0);
      return () => clearTimeout(timeout);
    };
    t4 = [codonationCents, setValue];
    $[6] = codonationCents;
    $[7] = setValue;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== codonationCents || $[11] !== resetAnalyticsState || $[12] !== setValue) {
    t5 = () => {
      setValue(codonationCents);
      resetAnalyticsState();
    };
    $[10] = codonationCents;
    $[11] = resetAnalyticsState;
    $[12] = setValue;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const reset = t5;
  let t6;
  if ($[14] !== commitValue || $[15] !== reset || $[16] !== setValue || $[17] !== value) {
    t6 = [value, setValue, commitValue, reset];
    $[14] = commitValue;
    $[15] = reset;
    $[16] = setValue;
    $[17] = value;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6 as const;
}
export default useCodonationValue;